import React, { useSyncExternalStore } from "react";

import { useLiteAppContext } from "@app/helpers/hooks";
import IntlProviderService from "@app/services/intl-provider";

// Stable stub reference to avoid unnecessary re-renders
function subscribe() {
  return () => {};
}

export const useIntlProvider = () => {
  const { locale } = useLiteAppContext();
  const should_use_intl_provider = useSyncExternalStore(
    subscribe,
    () => typeof Intl !== "undefined",
    () => false
  );

  const intlProvider = React.useMemo(() => {
    return should_use_intl_provider
      ? new IntlProviderService({
          locale,
          // Currency doesn't really matter here. It's required to construct valid IntlProvider though.
          // It means our IntlProvider has too many responsibilities, we're only using a few here.
          currency: "USD"
        })
      : null;
  }, [locale, should_use_intl_provider]);

  const getLocalizedDate = React.useCallback(
    (date: string): string => {
      if (!intlProvider || !date) {
        return date;
      }

      return (
        intlProvider.formatDate(date, {
          weekday: "short",
          month: "short",
          day: "numeric"
        }) || date
      );
    },
    [intlProvider]
  );

  return { getLocalizedDate };
};
